import React, { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

interface ProtectedRouteProps {
  children?: React.ReactNode;
  redirectTo?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectTo = "/login",
}) => {
  const { user, token } = useAuth();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Wait for localStorage/session restoration
    const timer = setTimeout(() => {
      setLoading(false);
    }, 100); // Small delay to ensure context updates
    return () => clearTimeout(timer);
  }, []);

  // Prevent redirect while checking localStorage
  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin h-8 w-8 border-b-2 border-primary rounded-full" />
        <p className="ml-3 text-muted-foreground">Loading...</p>
      </div>
    );
  }

  // If user is not logged in, redirect to login
  if (!user || !token) {
    return <Navigate to={redirectTo} replace />;
  }

  // If authenticated, render the page
  return <Outlet />;
};

export default ProtectedRoute;
